import Editor from './Editor';
import Viewer from './Viewer';

export default Editor;
export {
    Editor,
    Viewer
}